module.exports = __webpack_public_path__ + "img/icon_jd.c143d1f7.png";